export const transparent = 'transparent';
export const white = '#ffffff';

export const primary = '#00A1DE';
export const primaryHover = '#008CC2'

export const secondary ='#00549F';
export const quaternary = "#69BE28";
export const quinary = "#495979";

export const secondaryHover = '#00437E';
export const quaternaryHover = "#59AB1B";

export const lighterGrey = '#EEEEEE';
export const medGrey = '#737373';
export const formGrey = '#D8D8D8';

export const highlightYellow = '#fff9a7';

export const fontWeightNormal = '400';
export const fontWeightHeavy = '600';

export const fontSizeSmaller = '.6rem';
export const fontSizeSmall = '.75rem';



// WEBPACK FOOTER //
// ./src/styles/styled/colors.js